import React, { useState } from "react";
import { ChatProvider } from "./context/ChatContext";
import ChatWindow from "./components/ChatWindow";

function App() {
  const [username, setUsername] = useState("");
  const [chatId, setChatId] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);

  const handleLogin = () => {
    if (username.trim() && chatId.trim()) {
      setLoggedIn(true);
    }
  };

  if (!loggedIn) {
    return (
      <div className="login-container" style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        position: "relative",
        overflow: "hidden",
      }}>
        {/* Animated background elements */}
        <div style={{
          position: "absolute",
          width: "400px",
          height: "400px",
          background: "rgba(255, 255, 255, 0.1)",
          borderRadius: "50%",
          top: "-100px",
          left: "-100px",
          backdropFilter: "blur(100px)",
          animation: "float 20s ease-in-out infinite",
        }} />
        <div style={{
          position: "absolute",
          width: "200px",
          height: "200px",
          background: "rgba(255, 255, 255, 0.08)",
          borderRadius: "50%",
          bottom: "-50px",
          right: "-50px",
          backdropFilter: "blur(100px)",
          animation: "float 25s ease-in-out infinite reverse",
        }} />
        <div style={{
          backgroundColor: "rgba(255, 255, 255, 0.25)",
          padding: "60px 60px",
          borderRadius: "20px",
          boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.3)",
          textAlign: "center",
          zIndex: 10,
          maxWidth: "420px",
        }}>
          <h1 style={{
            color: "white",
            fontSize: "2.8em",
            margin: "0 0 20px 0",
            fontWeight: "700",
            letterSpacing: "-0.5px",
          }}>Chat Room</h1>
          <p style={{
            color: "rgba(255, 255, 255, 0.8)",
            fontSize: "0.9em",
            marginBottom: "40px",
            fontWeight: "300",
            lineHeight: "1.6",
          }}>Enter your username and chat room ID to join</p>
          <input
            type="text"
            placeholder="Your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleLogin()}
            style={{
              padding: "10px 10px",
              fontSize: "14px",
              width: "100%",
              marginBottom: "14px",
              boxSizing: "border-box",
              borderRadius: "12px",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              background: "rgba(255, 255, 255, 0.1)",
              color: "white",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              transition: "all 0.3s ease",
              outline: "none",
            }}
            onFocus={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.2)";
              e.target.style.borderColor = "rgba(255, 255, 255, 0.5)";
            }}
            onBlur={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.1)";
              e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
            }}
          />
          <style>{`input::placeholder { color: rgba(255, 255, 255, 0.6); }`}</style>
          <input
            type="text"
            placeholder="Chat room ID"
            value={chatId}
            onChange={(e) => setChatId(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleLogin()}
            style={{
              padding: "10px 10px",
              fontSize: "14px",
              width: "100%",
              marginBottom: "25px",
              boxSizing: "border-box",
              borderRadius: "12px",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              background: "rgba(255, 255, 255, 0.1)",
              color: "white",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              transition: "all 0.3s ease",
              outline: "none",
            }}
            onFocus={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.2)";
              e.target.style.borderColor = "rgba(255, 255, 255, 0.5)";
            }}
            onBlur={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.1)";
              e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
            }}
          />
          <button
            onClick={handleLogin}
            style={{
              padding: "10px 10px",
              fontSize: "0.98em",
              fontWeight: "600",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              color: "white",
              border: "1.5px solid rgba(255, 255, 255, 0.4)",
              borderRadius: "12px",
              cursor: "pointer",
              width: "100%",
              background: "linear-gradient(135deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.1))",
              transition: "all 0.3s ease",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
              e.currentTarget.style.boxShadow = "0 8px 32px 0 rgba(255, 255, 255, 0.2)";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            Join Chat
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      position: "relative",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    }}>
      {/* Animated background elements */}
      <div style={{
        position: "fixed",
        width: "400px",
        height: "400px",
        background: "rgba(255, 255, 255, 0.1)",
        borderRadius: "50%",
        top: "-100px",
        left: "-100px",
        backdropFilter: "blur(100px)",
        animation: "float 20s ease-in-out infinite",
        zIndex: 0,
      }} />
      <div style={{
        position: "fixed",
        width: "300px",
        height: "300px",
        background: "rgba(255, 255, 255, 0.08)",
        borderRadius: "50%",
        bottom: "-50px",
        right: "-50px",
        backdropFilter: "blur(100px)",
        animation: "float 25s ease-in-out infinite reverse",
        zIndex: 0,
      }} />
      <div style={{ position: "relative", zIndex: 1, width: "100%", maxWidth: "520px", padding: "20px" }}>
        <ChatProvider username={username} chatId={chatId}>
          <ChatWindow />
        </ChatProvider>
      </div>
    </div>
  );
}

export default App;
